import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios
    .get(`${url}/workshop/workshop_spare_part_requests`, options)
    .then((response) => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta,
      };
    });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/workshop/workshop_spare_part_requests/${id}`, options)
    .then((response) => {
      let spare_part_request_masters = jsona.deserialize(response.data);
      delete spare_part_request_masters.links;
      return spare_part_request_masters;
    });
}

function add(spare_part_request_masters) {
  console.log(spare_part_request_masters);
  const payload = jsona.serialize({
    stuff: spare_part_request_masters,
    includeNames: null,
  });
  console.log(payload);
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/workshop/workshop_spare_part_requests`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(spare_part_request_masters) {
  const payload = jsona.serialize({
    stuff: spare_part_request_masters,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/workshop/workshop_spare_part_requests/${spare_part_request_masters.id}`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(
    `${url}/workshop/workshop_spare_part_requests/${id}`,
    options
  );
}

function last_no() {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/workshop/workshop_spare_part_requests/last/no`, options)
    .then((response) => {
      return response.data;
    });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  last_no,
};
